import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import withData from 'components/withData';
import { UPLOAD_STATUS } from 'Data/constants';

import { UploadStateContext } from './';
import { getNormalizationUploadStatus } from 'utils/apiRequests';

const OVERVIEW_PATH = '/spend/overview';

class Provider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		response: PropTypes.shape({
			loading: PropTypes.bool,
			data: PropTypes.any,
			refetch: PropTypes.func,
		}),
	};

	state = {
		status: null,
		previousStatus: null,
		normalizationUploadStatus: 0,
	};

	componentWillReceiveProps(nextProps) {
		const { response } = nextProps;
		const { previousStatus } = this.state;

		if (response.success && !this.props.response.success) {
			this.setState({
				status: response.data,
			});
			getNormalizationUploadStatus().then(response => {
				this.setState({ normalizationUploadStatus: response });
			});

			if (
				previousStatus &&
				previousStatus.state !== response.data.state &&
				previousStatus.state === UPLOAD_STATUS.CLASSIFIED
			) {
				this.setState({ previousStatus: null });
				this.props.history.push(OVERVIEW_PATH);
			}
		}
	}

	handleRefetch = forceChildrenUpdate => {
		if (forceChildrenUpdate) {
			this.setState({ status: null, previousStatus: this.state.status });
		}

		this.props.response.refetch();
	};

	render() {
		return (
			<UploadStateContext.Provider
				value={{
					...this.state,
					refetch: this.handleRefetch,
				}}
			>
				{this.state.status || this.props.response.success
					? this.props.children
					: null}
			</UploadStateContext.Provider>
		);
	}
}

export const UploadStateContextProvider = withRouter(
	withData('/data-classification/state')(Provider)
);
